<template>
  <section id="crossfade-container">
    <section id="crossfade" @drag="crossFade"></section>
  </section>
</template>

<script>
export default {
  methods: {
    crossFade() {
      // Logic for crossfading between two audio tracks
    }
  }
};
</script>
